import { render, staticRenderFns } from "./getCustomers.vue?vue&type=template&id=02371caa&scoped=true"
import script from "./getCustomers.vue?vue&type=script&lang=js"
export * from "./getCustomers.vue?vue&type=script&lang=js"
import style0 from "./getCustomers.vue?vue&type=style&index=0&id=02371caa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02371caa",
  null
  
)

export default component.exports